import BigNumber from 'bignumber.js';
import { authTokenSelector } from '../selectors/auth';
import { CexAPI, store } from '../store/createStore';

export const fetchCEXBalance = async (exchange: string, asset: string) => {
  const loggedIn = store.getState().auth.loggedIn;

  if (loggedIn) {
    const token = authTokenSelector(store.getState());
    try {
      const res = await CexAPI.checkEnabledExchanges(token!);
      if (res.success && res.data) {
        const exchangeState = res.data.exchanges.find(
          (item) => item.name === exchange
        );
        if (exchangeState?.balance) {
          const found = exchangeState.balance.find(
            (item) => item.coin == asset
          );
          return found ? new BigNumber(found.available) : new BigNumber(0);
        }
      }

      return new BigNumber(0);
    } catch (error) {
      return new BigNumber(0);
    }
  } else {
    return new BigNumber(0);
  }
};
